// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__mfy5d","title":"Projects_title__ZerUl"};